
































































import Vue from 'vue';
import { HeroImage, Button } from '@/components/ds';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import steps from '@/pipeline/steps';
import i18n from '@/i18n';
import { getAssetPath } from '@/helpers/assets';
import { downloadBase64File } from '@/helpers/download';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import accounts, { Provider } from '@/helpers/accountsIframe';
import Analytics from '@/helpers/analytics';
import LoadingPage from '@/components/LoadingPage.vue';
import { SignUpMethod } from '@/helpers/westeros';
import {
  callPostPaymentApi,
  callUnicoGetPaymentApi,
  preparePostPaymentData,
} from '@/helpers/postPaymentApi';

export default Vue.extend({
  components: { HeroImage, BottomButton, Button, PipelineMenuWrapper, LoadingPage },
  props: {
    showPaymentDetailButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBankSlipFileLoading: false,
      isPageLoading: false,
      isCallAnalyticsActionsPaymentConfirmed: false,
      intervalStatusEnrollment: null as NodeJS.Timeout | null,
    };
  },
  computed: {
    backgroundSrc(): string {
      if (this.isSuccess || this.isPendingPayment) return getAssetPath('img/hero-bg-image.svg');

      return '';
    },
    currentPaymentMethod(): 'bankSlip' | 'creditCard' | 'pix' {
      return this.$store.getters.currentPaymentMethod;
    },
    paymentMethod(): string {
      switch (this.$store.getters.currentPaymentMethod) {
        case 'bankSlip':
          return 'Boleto';
        case 'creditCard':
          return 'Cartao de credito';
        case 'pix':
          return 'PIX';
        default:
          return this.$store.getters.currentPaymentMethod;
      }
    },
    freshmanLifeGreenIconSrc() {
      return getAssetPath('img/freshman-life-green.svg');
    },
    iconSrc(): string {
      if (this.isFailPayment) return getAssetPath('img/vish.svg');
      if (this.isPendingPayment) return getAssetPath('img/cmon.svg');

      return '';
    },
    imgSrc(): string {
      if (this.isSuccess) return getAssetPath('img/result/success.jpg');
      if (this.isFailPayment) return getAssetPath('img/result/fail.jpg');
      if (this.isPendingPayment) return getAssetPath('img/result/pending.jpg');

      return '';
    },
    isShowBankSlip(): boolean {
      return this.isPendingPayment && this.currentPaymentMethod === 'bankSlip';
    },
    isShowPaymentDetailButton(): boolean {
      return this.isPendingPayment && this.showPaymentDetailButton;
    },
    isFailPayment(): boolean {
      return this.$store.getters.enrollmentStatus === 'failPayment';
    },
    isPendingPayment(): boolean {
      return this.$store.getters.enrollmentStatus === 'pendingPayment';
    },
    isSuccess(): boolean {
      return this.$store.getters.enrollmentStatus === 'success';
    },
    enrollmentStatus(): string {
      return this.$store.getters.enrollmentStatus;
    },
    isRecurrentCreditCard(): string {
      return this.$store.getters.isRecurrentCreditCard;
    },
    isBottomButtonShowing(): boolean {
      return this.isSuccess || this.isShowBankSlip || this.isFailPayment;
    },
    maskUrl(): string {
      if (this.isPendingPayment || this.isFailPayment) return getAssetPath('img/mask.svg');
      if (this.isSuccess) return getAssetPath('img/mask2.svg');

      return '';
    },
    name(): string {
      return this.$store.getters.studentFirstName;
    },
    subtitle(): string {
      if (this.isSuccess) {
        return i18n.t(`enrollmentResult.success.subtitle.${this.currentAccountsStatus}`);
      }
      if (this.isFailPayment) return i18n.t('enrollmentResult.failPayment.subtitle');
      if (this.isPendingPayment && this.currentPaymentMethod === 'creditCard')
        return i18n.t(`enrollmentResult.pendingPayment.subtitle.${this.currentPaymentMethod}`);
      if (this.isPendingPayment)
        return i18n.t(
          `enrollmentResult.pendingPayment.subtitle.${this.currentPaymentMethod}.${this.currentAccountsStatus}`,
        );

      return '';
    },
    title(): string {
      const { name } = this;
      if (this.isSuccess) return i18n.t('enrollmentResult.success.title');
      if (this.isFailPayment) return i18n.t('enrollmentResult.failPayment.title', { name });
      if (this.isPendingPayment)
        return i18n.t(`enrollmentResult.pendingPayment.title.${this.currentPaymentMethod}`);
      return '';
    },
    bankSlipFile(): string {
      const { bankSlipFile } = this.$store.getters;
      return bankSlipFile;
    },
    studentEmail(): string {
      return this.$store.getters.personalData.email;
    },
    studentEmailHasAccounts(): boolean {
      return this.$store.getters.studentEmailHasAccounts;
    },
    studentAccountsHasSocialLogin(): boolean {
      const { GOOGLE, FACEBOOK, APPLE } = Provider;
      const { studentEmailProviders } = this.$store.getters;
      return studentEmailProviders.some((provider: Provider) =>
        [GOOGLE, FACEBOOK, APPLE].includes(provider),
      );
    },
    isLoggedInAccountsWithStudentEmail(): boolean {
      const { emailTokenD } = this.$store.getters;
      return emailTokenD === this.studentEmail;
    },
    currentAccountsStatus(): 'signIn' | 'signUp' | 'signed' {
      if (this.studentEmailHasAccounts) {
        return this.isLoggedInAccountsWithStudentEmail ? 'signed' : 'signIn';
      }

      return 'signUp';
    },
    shouldContinueToAccountResult(): boolean {
      const IsAccountsSignup = this.$store.getters?.studentSignupMethod === SignUpMethod.accounts;

      const isLoggedInAccounts = IsAccountsSignup || this.isLoggedInAccountsWithStudentEmail;

      return isLoggedInAccounts && (this.isSuccess || this.isShowBankSlip);
    },
    bottomButtonText(): string {
      return this.isFailPayment
        ? i18n.t('enrollmentResult.failPayment.button')
        : i18n.t(`enrollmentResult.success.${this.currentAccountsStatus}Button`);
    },
    studentAcademicRecord(): string {
      return this.$store.getters.backofficeStudentAcademicRecord;
    },
  },
  watch: {
    enrollmentStatus: {
      handler() {
        if (this.isSuccess) {
          if (!this.isCallAnalyticsActionsPaymentConfirmed)
            this.callAnalyticsActionsPaymentConfirmed();
        }
        if (this.isPendingPayment && this.currentPaymentMethod !== 'bankSlip') {
          this.startPollingStatusEnrollment();
        } else {
          if (
            this.isFailPayment &&
            this.currentPaymentMethod === 'creditCard' &&
            this.isRecurrentCreditCard
          ) {
            this.$store.dispatch('REMOVE_RECURRENT_CREDIT_CARD');
          }

          this.stopPollingStatusEnrollment();
          this.$nextTick(() => {
            this.goToAccountResult();
          });
        }
      },
      immediate: true,
    },
  },
  async created() {
    const enrollmentStatus: 'failPayment' | 'pendingPayment' | 'success' =
      this.$store.getters.enrollmentStatus || 'pendingPayment';
    const step = steps[enrollmentStatus];

    if (pipeline?.currentStep !== step) {
      pipeline.goTo(step);
    }

    this.isPageLoading = true;

    if (this.isSuccess) {
      this.callAnalyticsActionsPaymentConfirmed();
    }

    if (accounts.isLogged()) {
      await this.$store.dispatch('GET_TOKEND_INFO');
    }

    await this.$store.dispatch('GET_USER_ACCOUNTS');
  },
  mounted() {
    this.isPageLoading = false;
  },
  methods: {
    async downloadBankSlipFile() {
      this.isBankSlipFileLoading = true;
      await this.$store.dispatch('GENERATE_BANK_SLIP');

      downloadBase64File(this.bankSlipFile, 'boleto-descomplica.pdf', 'application/pdf');
      this.isBankSlipFileLoading = false;
    },
    async logoutAccountsWhenIsNotTheRightEmail() {
      const accountsIsLogged = accounts.isLogged();

      if (!accountsIsLogged) return;

      if (!this.isLoggedInAccountsWithStudentEmail) {
        accounts.logout();
      }

      Analytics.trackMixpanel('Já tinha accounts - estava logado com ele.');
    },
    retryPayment() {
      pipeline.next();
    },
    goToAccounts(): void {
      this.logoutAccountsWhenIsNotTheRightEmail();

      const target =
        this.currentAccountsStatus === 'signed' ? steps.accountsResult : steps.accounts;
      pipeline.next({ value: target });
    },
    handleBottomButtonClick(): void {
      return this.isFailPayment ? this.retryPayment() : this.goToAccounts();
    },
    async startPollingStatusEnrollment() {
      this.stopPollingStatusEnrollment();
      await this.$store.dispatch('GET_ENROLLMENT');

      this.intervalStatusEnrollment = setInterval(async () => {
        await this.$store.dispatch('GET_ENROLLMENT');
      }, 10000);
    },
    stopPollingStatusEnrollment() {
      if (this.intervalStatusEnrollment) {
        clearInterval(this.intervalStatusEnrollment);
        this.intervalStatusEnrollment = null;
      }
    },
    async callAnalyticsActionsPaymentConfirmed() {
      this.isCallAnalyticsActionsPaymentConfirmed = true;
      await this.$store.dispatch(AnalyticsActions.PAYMENT_CONFIRMED, {
        paymentMethod: this.paymentMethod,
        academicRecordId: this.studentAcademicRecord,
      });
    },
    goToAccountResult() {
      if (this.shouldContinueToAccountResult) {
        this.isPageLoading = true;
        Promise.all([this.releaseAddonModuleToUser(), this.callPostPaymentApi()]).finally(() => {
          this.isPageLoading = false;
          pipeline.next({ value: steps.accountsResult });
        });
      }
    },
    async callPostPaymentApi() {
      try {
        const postPaymentData = preparePostPaymentData(this.studentAcademicRecord);

        if (postPaymentData) {
          await callPostPaymentApi(postPaymentData);
          if (postPaymentData.partner === 'unico') {
            await callUnicoGetPaymentApi();
          }
        }
      } catch (apiError) {
        // suppress error
      }
    },
    async releaseAddonModuleToUser() {
      await this.$store.dispatch('RELEASE_COMPLEMENTARY_MODULE_TO_USER');
      if (this.$store.getters.isComplementaryModuleEnabled) {
        const currentPage = 'SignUp Completed';
        await this.$store.dispatch('COMPLEMENTARY_ACCESS', currentPage);
      }
    },
  },
});
